// @generated by protoc-gen-connect-query v2.0.1 with parameter "target=ts"
// @generated from file api/v1/api.proto (package api.v1, syntax proto3)
/* eslint-disable */

import { ApiService } from "./api_pb";

/**
 * @generated from rpc api.v1.ApiService.GetPost
 */
export const getPost = ApiService.method.getPost;

/**
 * @generated from rpc api.v1.ApiService.GetUser
 */
export const getUser = ApiService.method.getUser;

/**
 * @generated from rpc api.v1.ApiService.ListCategories
 */
export const listCategories = ApiService.method.listCategories;

/**
 * @generated from rpc api.v1.ApiService.ListFollowers
 */
export const listFollowers = ApiService.method.listFollowers;

/**
 * @generated from rpc api.v1.ApiService.ListFollowing
 */
export const listFollowing = ApiService.method.listFollowing;

/**
 * @generated from rpc api.v1.ApiService.ListPosts
 */
export const listPosts = ApiService.method.listPosts;

/**
 * @generated from rpc api.v1.ApiService.ListPostsByUserID
 */
export const listPostsByUserID = ApiService.method.listPostsByUserID;

/**
 * @generated from rpc api.v1.ApiService.ListPostComments
 */
export const listPostComments = ApiService.method.listPostComments;

/**
 * @generated from rpc api.v1.ApiService.Logout
 */
export const logout = ApiService.method.logout;

/**
 * @generated from rpc api.v1.ApiService.Refresh
 */
export const refresh = ApiService.method.refresh;

/**
 * @generated from rpc api.v1.ApiService.Whoami
 */
export const whoami = ApiService.method.whoami;

/**
 * Blocked users
 *
 * @generated from rpc api.v1.ApiService.BlockUser
 */
export const blockUser = ApiService.method.blockUser;

/**
 * @generated from rpc api.v1.ApiService.UnblockUser
 */
export const unblockUser = ApiService.method.unblockUser;

/**
 * Bookmarks
 *
 * @generated from rpc api.v1.ApiService.BookmarkPost
 */
export const bookmarkPost = ApiService.method.bookmarkPost;

/**
 * @generated from rpc api.v1.ApiService.DeleteBookmark
 */
export const deleteBookmark = ApiService.method.deleteBookmark;

/**
 * @generated from rpc api.v1.ApiService.UpdateBookmark
 */
export const updateBookmark = ApiService.method.updateBookmark;

/**
 * Bookmark Categories
 *
 * @generated from rpc api.v1.ApiService.CreateBookmarkCategory
 */
export const createBookmarkCategory = ApiService.method.createBookmarkCategory;

/**
 * @generated from rpc api.v1.ApiService.DeleteBookmarkCategory
 */
export const deleteBookmarkCategory = ApiService.method.deleteBookmarkCategory;

/**
 * Follows
 *
 * @generated from rpc api.v1.ApiService.FollowUser
 */
export const followUser = ApiService.method.followUser;

/**
 * @generated from rpc api.v1.ApiService.RemoveFollower
 */
export const removeFollower = ApiService.method.removeFollower;

/**
 * @generated from rpc api.v1.ApiService.UnfollowUser
 */
export const unfollowUser = ApiService.method.unfollowUser;

/**
 * Posts
 *
 * @generated from rpc api.v1.ApiService.CreatePost
 */
export const createPost = ApiService.method.createPost;

/**
 * @generated from rpc api.v1.ApiService.DeletePost
 */
export const deletePost = ApiService.method.deletePost;

/**
 * @generated from rpc api.v1.ApiService.LikePost
 */
export const likePost = ApiService.method.likePost;

/**
 * @generated from rpc api.v1.ApiService.UnlikePost
 */
export const unlikePost = ApiService.method.unlikePost;

/**
 * Post Comments
 *
 * @generated from rpc api.v1.ApiService.CreatePostComment
 */
export const createPostComment = ApiService.method.createPostComment;

/**
 * @generated from rpc api.v1.ApiService.DeletePostComment
 */
export const deletePostComment = ApiService.method.deletePostComment;

/**
 * @generated from rpc api.v1.ApiService.LikePostComment
 */
export const likePostComment = ApiService.method.likePostComment;

/**
 * @generated from rpc api.v1.ApiService.ListPostCommentReplies
 */
export const listPostCommentReplies = ApiService.method.listPostCommentReplies;

/**
 * @generated from rpc api.v1.ApiService.UnlikePostComment
 */
export const unlikePostComment = ApiService.method.unlikePostComment;

/**
 * Me
 *
 * @generated from rpc api.v1.ApiService.GetMyContentSettings
 */
export const getMyContentSettings = ApiService.method.getMyContentSettings;

/**
 * @generated from rpc api.v1.ApiService.GetMyPrivacySettings
 */
export const getMyPrivacySettings = ApiService.method.getMyPrivacySettings;

/**
 * @generated from rpc api.v1.ApiService.ListMyBlockedUsers
 */
export const listMyBlockedUsers = ApiService.method.listMyBlockedUsers;

/**
 * @generated from rpc api.v1.ApiService.UpdateMe
 */
export const updateMe = ApiService.method.updateMe;

/**
 * @generated from rpc api.v1.ApiService.UpdateMyContentSettings
 */
export const updateMyContentSettings = ApiService.method.updateMyContentSettings;

/**
 * @generated from rpc api.v1.ApiService.UpdateMyPrivacySettings
 */
export const updateMyPrivacySettings = ApiService.method.updateMyPrivacySettings;

/**
 * @generated from rpc api.v1.ApiService.UpdateMyProfilePicture
 */
export const updateMyProfilePicture = ApiService.method.updateMyProfilePicture;

/**
 * Users
 *
 * @generated from rpc api.v1.ApiService.GetUserByUsername
 */
export const getUserByUsername = ApiService.method.getUserByUsername;

/**
 * OAuth
 *
 * @generated from rpc api.v1.ApiService.GetGoogleOAuthRedirectURL
 */
export const getGoogleOAuthRedirectURL = ApiService.method.getGoogleOAuthRedirectURL;

/**
 * @generated from rpc api.v1.ApiService.RedeemGoogleOAuthCode
 */
export const redeemGoogleOAuthCode = ApiService.method.redeemGoogleOAuthCode;

/**
 * Uploads
 *
 * @generated from rpc api.v1.ApiService.GetPresignedUploadURL
 */
export const getPresignedUploadURL = ApiService.method.getPresignedUploadURL;

/**
 * Intermediate Sessions
 *
 * @generated from rpc api.v1.ApiService.CreateIntermediateSession
 */
export const createIntermediateSession = ApiService.method.createIntermediateSession;

/**
 * @generated from rpc api.v1.ApiService.RevokeIntermediateSession
 */
export const revokeIntermediateSession = ApiService.method.revokeIntermediateSession;

/**
 * @generated from rpc api.v1.ApiService.SetIntermediateSessionEmail
 */
export const setIntermediateSessionEmail = ApiService.method.setIntermediateSessionEmail;

/**
 * @generated from rpc api.v1.ApiService.SetIntermediateSessionPhoneNumber
 */
export const setIntermediateSessionPhoneNumber = ApiService.method.setIntermediateSessionPhoneNumber;

/**
 * @generated from rpc api.v1.ApiService.SetIntermediateSessionUsername
 */
export const setIntermediateSessionUsername = ApiService.method.setIntermediateSessionUsername;

/**
 * Sessions
 *
 * @generated from rpc api.v1.ApiService.Exchange
 */
export const exchange = ApiService.method.exchange;

/**
 * Verification
 *
 * @generated from rpc api.v1.ApiService.IssueEmailVerificationChallenge
 */
export const issueEmailVerificationChallenge = ApiService.method.issueEmailVerificationChallenge;

/**
 * @generated from rpc api.v1.ApiService.VerifyEmailVerificationChallenge
 */
export const verifyEmailVerificationChallenge = ApiService.method.verifyEmailVerificationChallenge;

/**
 * @generated from rpc api.v1.ApiService.IssuePhoneNumberVerificationChallenge
 */
export const issuePhoneNumberVerificationChallenge = ApiService.method.issuePhoneNumberVerificationChallenge;

/**
 * @generated from rpc api.v1.ApiService.VerifyPhoneNumberVerificationChallenge
 */
export const verifyPhoneNumberVerificationChallenge = ApiService.method.verifyPhoneNumberVerificationChallenge;

/**
 * Passwords
 *
 * @generated from rpc api.v1.ApiService.RegisterPassword
 */
export const registerPassword = ApiService.method.registerPassword;

/**
 * @generated from rpc api.v1.ApiService.VerifyPassword
 */
export const verifyPassword = ApiService.method.verifyPassword;
